import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import Navigation from '../components/Navigation';
import { toast } from 'sonner';
import { BuyModal } from '../components/Buy/BuyModal';

const Section = styled.section`
  width: 100vw;
  position: relative;
  background-color: ${props => props.theme.body};
`;

const Container = styled.div`
  padding: 2rem;
  background: ${props => props.theme.body};
  color: ${props => props.theme.text};
  display: flex;
  flex-direction: row;
  justify-content: center;
    gap: 2rem;
  text-align: left; /* Align text inside this div to the left */
  @media (max-width: 64em) {
    width: 85%;
    padding: 2rem;
    background: ${props => props.theme.body};
    color: ${props => props.theme.text};
    display: flex;
    flex-direction: column;
    text-align: left;
  }
`;

const Img = styled.img`
  width: 50%;
  max-height: 80vh;
  border-radius: 1rem;
    @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const Details = styled.div`
  margin-top: 1rem;
  text-align: left; /* Align text inside this div to the left */

  h1 {
    font-size: 2rem;
    margin: 0.5rem 0;
  }

  p {
    font-size: 1.2rem;
    color: gray;
    margin: 0.3rem 0;
  }
`;

const Rating = styled.div`
  margin-top: 1rem;
  font-size: 1.2rem;
`;

const Creator = styled.div`
  margin-top: 1rem;
  font-size: 1.2rem;
  word-break: break-all;
  border: 1px solid ${props => props.theme.text};
  border-radius: 0.5rem;
  padding: 0.5rem;
`;

const Owner = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  border: 1px solid ${props => props.theme.text};
  border-radius: 0.5rem;
  padding: 0.5rem;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 0.8rem;
  }
`;

const WalletAddress = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: ${props => props.theme.text};

  &:hover > span {
    opacity: 1;
  }
`;

const CopyTag = styled.span`
  background-color: #e0e0e0;
  color: #333;
  padding: 0.2rem 0.5rem;
  border-radius: 0.4rem;
  font-size: 0.6rem;
  opacity: 0.7;
  transition: opacity 0.2s;
  @media (max-width: 48em) {
    width: 15%;
  }
`;

const Name = styled.div`
    display: flex;
    flex-direction: column;
`;

// const NftDetails = () => {
//   const { id } = useParams();
//   const { state } = useLocation();

//   const [isBuying, setIsBuying] = useState(false);

//   if (!state) {
//     return (
//       <Container>
//         <h1>Item not found</h1>
//       </Container>
//     );
//   }

//   const { img, number, price, owner, ownerImg, wallet_address, description, art } = state;

//   const wallet = wallet_address ?? process.env.REACT_APP_WALLET ?? "No wallet available";

//   const handleCopy = (text) => {
//     navigator.clipboard.writeText(wallet).then(() => {
//       toast.success("Wallet address copied!");
//       console.log(text);
//     });
//   };

//   const handleBuy = () => {
//     // your buy logic goes here
//     console.log("Buying NFT:", art);
//     setIsBuying(false);
//   };

//   return (
//     <Section id="ConnectWallet">
//       <Navigation />
//       <Container>
//         <Img src={img} alt={`NFT #${number}`} />
//         <Details>
//           <h1>{number}</h1>
//           <p>Price: {price} ETH</p>
//           <p>ID from URL: {id}</p>
//           <p>Description: {description}</p>

//           <Rating>⭐ ⭐ ⭐ ⭐ ⭐</Rating>

//           <Creator>
//             <p>Creator:</p>
//             <WalletAddress
//               onClick={() =>
//                 handleCopy("0xa21921ea739de956a7d5643c5f72bdbb1e9d2e0d")
//               }
//             >
//               <span>{wallet}</span>
//               <CopyTag>Copy</CopyTag>
//             </WalletAddress>
//           </Creator>

//           <Owner>
//             <img src={ownerImg} alt="Owner profile" />
//             <Name>
//               <p>Owner:</p>
//               <p>@{owner}</p>
//             </Name>
//           </Owner>

//           {/* ✅ Buy button + BuyArtModal */}
//           {art && (
//             < >
//               <Button className="mintButton" style={{ "margin-top": "20px"}} text="BUY" onClick={() => setIsBuying(true)} />
//               {isBuying && (
//                 <BuyArtModal
//                   art={art}
//                   onClose={() => setIsBuying(false)}
//                   onBuy={handleBuy}
//                 />
//               )}
//             </>
//           )}
//         </Details>
//       </Container>
//     </Section>
//   );
// };

const NftDetails = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const [nft, setNft] = useState(state || null);
  console.log(nft)

  useEffect(() => {
    if (!nft) {
      // fallback fetch if state is missing
      fetch(`https://api.example.com/nfts/${id}`)
        .then(res => res.json())
        .then(data => setNft(data))
        .catch(err => console.error(err));
    }
  }, [id, nft]);

  // if (!state) {
  //   return (
  //     <Container>
  //       <h1>Item not found</h1>
  //     </Container>
  //   );
  // }

  const { img, number, price, owner, ownerImg, wallet_address, description, art } = nft;

  const wallet = wallet_address ?? process.env.REACT_APP_WALLET ?? "No wallet available";

  const handleCopy = (text) => {
    navigator.clipboard.writeText(wallet).then(() => {
      toast.success("Wallet address copied!");
      console.log(text);
    });
  };

  return (
    <Section id="ConnectWallet">
      <Navigation />

      {/* ✅ If art exists, show BuyModal inside the Container */}
      <Container>
        {art ? (
          <BuyModal mintedArts={Array.isArray(art) ? art : [art]} />
        ) : (
          <>
            <Img src={img} alt={`NFT #${number}`} />
            <Details>
              <h1>{number}</h1>
              <p>Price: {price} ETH</p>
              <p>ID from URL: {id}</p>
              <p>Description: {description}</p>

              <Rating>⭐ ⭐ ⭐ ⭐ ⭐</Rating>

              <Creator>
                <p>Creator:</p>
                <WalletAddress
                  onClick={() =>
                    handleCopy("0xa21921ea739de956a7d5643c5f72bdbb1e9d2e0d")
                  }
                >
                  <span>{wallet}</span>
                  <CopyTag>Copy</CopyTag>
                </WalletAddress>
              </Creator>

              <Owner>
                <img src={ownerImg} alt="Owner profile" />
                <Name>
                  <p>Owner:</p>
                  <p>@{owner}</p>
                </Name>
              </Owner>
            </Details>
          </>
        )}
      </Container>
    </Section>
  );
};

export default NftDetails;